module.exports = __webpack_public_path__ + "img/cir_tick.e64da78b.svg";